// header-drawer.js – for Shopify "details" drawer pattern
document.addEventListener('DOMContentLoaded', () => {
  const drawer = document.querySelector('header-drawer');
  const details = drawer?.querySelector('#Details-menu-drawer-container');
  const summary = details?.querySelector('summary');

  if (!drawer || !details || !summary) return;

  summary.addEventListener('click', (e) => {
    e.preventDefault();
    const isOpen = details.hasAttribute('open');
    if (isOpen) {
      details.removeAttribute('open');
      drawer.removeAttribute('open');
      document.body.classList.remove('drawer-open');
    } else {
      details.setAttribute('open', true);
      drawer.setAttribute('open', true);
      document.body.classList.add('drawer-open');
    }
  });
});


